"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.augmentTrafficMeasurementsWithCustomDimensions = augmentTrafficMeasurementsWithCustomDimensions;
exports.transformCustomDimensions = transformCustomDimensions;
var _query = require("@kentik/ui-shared/query/query");
function getInverseColName(colName) {
  if (/_src(_|$)/i.test(colName)) {
    return colName.replace(/_src(_|$)/gi, '_dst$1');
  }
  if (/_dst(_|$)/i.test(colName)) {
    return colName.replace(/_dst(_|$)/gi, '_src$1');
  }
  if (/_in(_|$)/i.test(colName)) {
    return colName.replace(/_in(_|$)/gi, '_out$1');
  }
  if (/_out(_|$)/i.test(colName)) {
    return colName.replace(/_out(_|$)/gi, '_in$1');
  }
  if (/_to(_|$)/i.test(colName)) {
    return colName.replace(/_to(_|$)/gi, '_from$1');
  }
  if (/_from(_|$)/i.test(colName)) {
    return colName.replace(/_from(_|$)/gi, '_to$1');
  }
  return undefined;
}
function transformCustomDimensions(dimensions) {
  const validDimensions = dimensions.filter(d => typeof d.col_name === 'string' && d.col_name.length > 0);
  const colNameSet = new Set(validDimensions.map(d => d.col_name));
  return validDimensions.reduce((acc, dim) => {
    let direction;
    if ((0, _query.isSrcDim)(dim.col_name)) {
      direction = 'src';
    } else if ((0, _query.isDstDim)(dim.col_name)) {
      direction = 'dst';
    }
    const inverse = getInverseColName(dim.col_name);
    const hasInversePair = inverse != null && colNameSet.has(inverse);
    const entry = {
      Label: dim.description,
      Column: dim.col_name,
      Type: dim.col_type === 'uint32' ? 'uint32' : 'string',
      Category: 'Custom',
      Shared: true
    };
    if (direction) {
      entry.Direction = direction;
    }
    if (hasInversePair) {
      entry.Inverse = inverse;
    }
    acc[dim.col_name] = entry;
    return acc;
  }, {});
}
function augmentTrafficMeasurementsWithCustomDimensions(allMeasurements, dimensions) {
  if (!dimensions.length) {
    return allMeasurements;
  }
  const customDims = transformCustomDimensions(dimensions);
  return allMeasurements.map(measurement => {
    if (!measurement.measurement.startsWith('/traffic')) {
      return measurement;
    }
    return {
      ...measurement,
      storage: {
        ...measurement.storage,
        Dimensions: {
          ...measurement.storage.Dimensions,
          ...customDims
        }
      }
    };
  });
}